@if (visible$ | async) {
  <app-chart-tile
    [title]="title"
    [options]="chartOptions || defaultOptions"
    [getSeries]="getSeries"
    [periodOptions]="periodOptions"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
